module.exports = __webpack_public_path__ + "img/icon3.f44baa92.png";